import { useEffect, useState } from "react";

export const TypeWord = ({ word, delay = 1100, speed = 110 }) => {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (n >= word.length) return undefined;
    const t = setTimeout(() => setN((v) => v + 1), n === 0 ? delay : speed);
    return () => clearTimeout(t);
  }, [n, word, delay, speed]);
  return (
    <span className="serif-accent relative inline-block font-normal text-[#D8CCFF]" aria-label={word} data-testid="hero-typed-word">
      <span className="invisible" aria-hidden>{word}</span>
      <span className="absolute inset-0 whitespace-nowrap" aria-hidden>
        {word.slice(0, n)}
        <span className="type-caret ml-1 inline-block h-[0.85em] w-[3px] translate-y-[0.08em] bg-[#FF7043]" />
      </span>
    </span>
  );
};
